import React, { useState } from "react";
import axios from "axios"; 
import "./style.css";
import Captcha from "../Captcha";

const FloatingMenu = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [realEstate, setRealEstate] = useState(false);
  const [wills, setWills] = useState(false);
  const [corporate, setCorporate] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isCaptchaCorrect, setIsCaptchaCorrect] = useState(false);

  const handleCaptchaChange = (isCorrect) => {
    setIsCaptchaCorrect(isCorrect);
  };

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleRealEstateChange = (e) => {
    setRealEstate(e.target.checked);
  };

  const handleWillsChange = (e) => {
    setWills(e.target.checked);
  };

  const handleCorporateChange = (e) => {
    setCorporate(e.target.checked);
  };

  const handleSubmit = (e) => {
    e.preventDefault();


    const data = {
      emailid: email,
      namefirst: firstName,
      namelast: lastName,
      source_of_registration: "Website",
      interested_in_real_estate: realEstate,
      interested_in_wills: wills,
      interested_in_corporate: corporate,
    };


    axios
      .post("https://jacobjose.azurewebsites.net/emailSubscriber/save", data)
      .then((response) => {
        console.log("Data sent successfully:", response.data);
      })
      .catch((error) => {
        console.error("Error sending data:", error);
      });
  };

  return (
    <div className={`floating-menu${isCollapsed ? "-collapsed" : ""}`}>
      <button className="close-button" onClick={handleCollapse}>
        X
      </button>
      <h2>Subscribe for Updates</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>
            First Name
            <input
              type="text"
              value={firstName}
              onChange={handleFirstNameChange}
              required
            />
          </label>
          <label>
            Last Name
            <input
              type="text"
              value={lastName}
              onChange={handleLastNameChange}
              required
            />
          </label>

          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              required
            />
          </label>
          <div>
            <label>Check all that interests you.</label>
            <label>
              <input
                type="checkbox"
                checked={realEstate}
                onChange={handleRealEstateChange}
              />
              Real Estate
            </label>
            <label>
              <input
                type="checkbox"
                checked={wills}
                onChange={handleWillsChange}
              />
              Wills
            </label>
            <label>
              <input
                type="checkbox"
                checked={corporate}
                onChange={handleCorporateChange}
              />
              Corporate
            </label>
          </div>
          <Captcha onCaptchaChange={handleCaptchaChange} />
          <button type="submit">Subscribe</button>
        </div>
      </form>
    </div>
  );
};

export default FloatingMenu;
